import React, { useRef } from "react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import Slider from "react-slick";

import imgMF from "../../assets/image/home-6/png/mobile-frame.png";
import imgDF from "../../assets/image/home-6/png/desktop-frame.png";
import imgS1 from "../../assets/image/home-6/png/screenshot-1.png";
import imgS2 from "../../assets/image/home-6/png/screenshot-2.png";
import imgS3 from "../../assets/image/home-6/png/screenshot-3.png";
import imgS4 from "../../assets/image/home-6/png/screenshot-4.png";
import imgS5 from "../../assets/image/home-6/png/screenshot-5.png";
import imgS6 from "../../assets/image/home-6/png/screenshot-6.png";
import imgD1 from "../../assets/image/home-6/jpg/d1.jpg";
import imgD2 from "../../assets/image/home-6/jpg/d2.jpg";
import imgD3 from "../../assets/image/home-6/jpg/d3.jpg";
import imgD4 from "../../assets/image/home-6/jpg/d4.jpg";
import imgD5 from "../../assets/image/home-6/jpg/d5.jpg";
import imgD6 from "../../assets/image/home-6/jpg/d6.jpg";

const Pricing = ({ className, ...rest }) => {
  const elSliderDesktop = useRef();
  const elSliderMobile = useRef();

  const slickSettings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    centerMode: true,
    centerPadding: "0",
    autoplay: false,
    autoplaySpeed: 3000,
    easing: "linear",
    speed: 500,
    appendDots: (dots) => (
      <>
        <div className="screenshots-dots pt-5 pt-md-10">
          <div className="slick-dots">{dots}</div>
        </div>
      </>
    ),

    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 1750,
        settings: {
          slidesToShow: 3,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1670,
        settings: {
          slidesToShow: 3,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1640,
        settings: {
          slidesToShow: 3,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 3,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 3,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 515,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          centerPadding: "0px",
          arrows: false,
        },
      },
    ],
  };
  const slickSettingsDesktop = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: "0px",
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    appendDots: (dots) => (
      <>
        <div className="screenshots-dots pt-5 pt-md-10">
          <div className="slick-dots">{dots}</div>
        </div>
      </>
    ),

    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1750,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1670,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1640,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 1,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 515,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          centerPadding: "0px",
          arrows: false,
        },
      },
    ],
  };    
  return (
    <>  
    <div className={className} {...rest}>
      <div>
        {/* section title */}
        <div className="row justify-content-center">
          <div className="col-12">
            <div
              className="text-center mb-8 dark-mode-texts"
              data-aos="fade-up"
              data-aos-delay={500}
              data-aos-once="true"
            >
              <h2 className="font-size-10 mb-2 letter-spacing-n83">
                Digma User Experience
              </h2>

            </div>
          </div>
        </div>
        {/* section title */}
        {/* Pricing Table */}
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <div className="row justify-content-center">
            <div
            className="col-xl-12 col-md-12 col-xs-12"
            data-aos="fade-right"
            data-aos-delay={500}
            data-aos-once="true"
          >
            <Nav
              variant="pills"
              className="nav col-xl-12 align-content-center justify-content-center justify-sm-content-between justify-content-xl-center mb-8 mb-lg-0"
            >
              <Nav.Item className="mr-5">
                <Nav.Link
                  eventKey="first"
                  className="nav-link btn btn-outline-white btn-xl h-55 mb-8 mx-1 mx-xl-0"
                >
                  Desktop
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="ml-5">
                <Nav.Link
                  eventKey="second"
                  className="nav-link btn btn-outline-white btn-xl h-55 mb-8 mx-1 mx-xl-0"
                >
                  Mobile
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
            <div className="col-xl-11 col-lg-11">
              <Tab.Content>
                <Tab.Pane eventKey="first">           
                  <div className="screenshot-slider-wrapper mb-5">
                    <div className="l2-category-slider text-center text-md-right">
                      <button
                        className="slick-prev slick-arrow test4"
                        aria-label="Previous"
                        type="button"
                        onClick={() => {
                          elSliderDesktop.current.slickPrev();
                        }}
                      >
                        <i className="icon icon-small-left"></i>
                      </button>
                      <button
                        className="slick-next slick-arrow"
                        aria-label="Next"
                        type="button"
                        onClick={() => {
                          elSliderDesktop.current.slickNext();
                        }}
                      >
                        <i className="icon icon-small-right"></i>
                      </button>    
                    </div>                      
                    <Slider ref={elSliderDesktop}
                        {...slickSettingsDesktop}
                        css={`
                          .slick-dots {
                            display: flex !important;
                          }
                        `}
                        className="screenshot-slider-desktop"
                      >
                        <div className="single-slide focus-reset">
                          <div className="desktop-screenshot-image">
                            <img src={imgD1} alt="Digma Interactive Video Desktop Version" />
                          </div>
                        </div>
                        <div className="single-slide focus-reset">
                          <div className="desktop-screenshot-image">
                            <img src={imgD2} alt="Digma Interactive Video Desktop Version" />
                          </div>
                        </div>
                        <div className="single-slide focus-reset">
                          <div className="desktop-screenshot-image">
                            <img src={imgD3} alt="Digma Interactive Video Desktop Version" />
                          </div>
                        </div>
                        <div className="single-slide focus-reset">
                          <div className="desktop-screenshot-image">
                            <img src={imgD4} alt="Digma Interactive Video Desktop Version" />
                          </div>
                        </div>
                        <div className="single-slide focus-reset">
                          <div className="desktop-screenshot-image">
                            <img src={imgD5} alt="Digma Interactive Video Desktop Version" />
                          </div>
                        </div>
                        <div className="single-slide focus-reset">
                          <div className="desktop-screenshot-image">
                            <img src={imgD6} alt="Digma Interactive Video Desktop Version" />
                          </div>
                        </div>
                      </Slider>
                    <div
                        className="desktop-bg-img"
                      >
                        <img src={imgDF} alt="Digma Interactive Video Desktop Background" />
                      </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <div className="screenshot-slider-wrapper mb-5">
                  <div className="l2-category-slider text-center text-md-right">
                      <button
                        className="slick-prev slick-arrow test5"
                        aria-label="Previous"
                        type="button"
                        onClick={() => {
                          elSliderMobile.current.slickPrev();
                        }}
                      >
                        <i className="icon icon-small-left"></i>
                      </button>
                      <button
                        className="slick-next slick-arrow"
                        aria-label="Next"
                        type="button"
                        onClick={() => {
                          elSliderMobile.current.slickNext();
                        }}
                      >
                        <i className="icon icon-small-right"></i>
                      </button>    
                    </div>                      
                    <Slider ref={elSliderMobile}
                      {...slickSettings}
                      css={`
                        .slick-dots {
                          display: flex !important;
                        }
                      `}
                      className="screenshot-slider"
                    >
                      <div className="single-slide focus-reset">
                        <div className="screenshot-image">
                          <img src={imgS1} alt="Digma Interactive Video Mobile Version" />
                        </div>
                      </div>
                      <div className="single-slide focus-reset">
                        <div className="screenshot-image">
                          <img src={imgS2} alt="Digma Interactive Video Mobile Version" />
                        </div>
                      </div>
                      <div className="single-slide focus-reset">
                        <div className="screenshot-image">
                          <img src={imgS3} alt="Digma Interactive Video Mobile Version" />
                        </div>
                      </div>
                      <div className="single-slide focus-reset">
                        <div className="screenshot-image">
                          <img src={imgS4} alt="Digma Interactive Video Mobile Version" />
                        </div>
                      </div>
                      <div className="single-slide focus-reset">
                        <div className="screenshot-image">
                          <img src={imgS5} alt="Digma Interactive Video Mobile Version" />
                        </div>
                      </div>
                      <div className="single-slide focus-reset">
                        <div className="screenshot-image">
                          <img src={imgS6} alt="Digma Interactive Video Mobile Version" />
                        </div>
                      </div>
                    </Slider>
                    <div
                      className="phone-bg-img"
                      css={`
                        @media (min-width: 690px) {
                          transform: translate(-50%, -53%) !important;
                        }
                      `}
                    >
                      <img src={imgMF} alt="" />
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
        {/* End Pricing Table */}
      </div>
    </div>
    </>
  );
};

export default Pricing;
